import React from 'react'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { ah, sh, compose, ReduxWrapper } from 'common-data/datahelpers'
import { FAIcon } from './FAIcon'
import { CircleButton } from './CircleButton'
import { FloatGroup } from './FloatGroup'
import { ToolTip } from './ToolTip'
import _ from 'common-tools/LodashHelper'

import styles from './DataCard.less'

class DataCardPlain extends React.Component {
  static pt = {
    picture: pt.shape({
      key: pt.string,
      icon: pt.string
    }),
    children: pt.element,
    loading: pt.bool.isRequired,
    rowSpan: pt.number.isRequired,
    colSpan: pt.number.isRequired,
    showGray: pt.bool,
    onClick: pt.oneOfType([
      pt.func,
      pt.string,
      pt.shape({
        url: pt.string,
        breadCrumbKey: pt.shape({
          key: pt.string,
          value: pt.string
        })
      })
    ])
  }

  static defaultProps = {
    loading: false,
    rowSpan: 2,
    colSpan: 2,
    showGray: false
  }

  render () {
    const { rowSpan, colSpan, children, onClick, sendToURL, addLayoutBreadCrumbKey, noCursor, showGray, style = {}, disabled } = this.props

    const cardStyle = style

    if (rowSpan > 1) {
      cardStyle.gridRowEnd = `span ${rowSpan}`
    }

    if (colSpan === 0) {
      cardStyle.gridColumnStart = 1
      cardStyle.gridColumnEnd = -1
    } else if (colSpan > 1) {
      cardStyle.gridColumnEnd = `span ${colSpan}`
    }
    if (noCursor) {
      cardStyle.cursor = 'default'
    }

    let onClickFunction = null

    if (_.isFunction(onClick)) {
      onClickFunction = onClick
    } else if (_.isString(onClick)) {
      onClickFunction = () => {
        sendToURL(onClick)
      }
    } else if (_.isPlainObject(onClick)) {
      onClickFunction = () => {
        if (_.isArray(onClick.breadCrumbKey)) {
          _.each(onClick.breadCrumbKey, (bk) => {
            addLayoutBreadCrumbKey(bk.key, bk.value, bk.disabled)
          })
        } else {
          addLayoutBreadCrumbKey(onClick.breadCrumbKey.key, onClick.breadCrumbKey.value, onClick.breadCrumbKey.disabled)
        }
        sendToURL(onClick.url, onClick.state || {})
      }
    }
    return (
      <div style={cardStyle} className={`${styles.datacard} ${showGray ? styles.disabled : ''}`} onClick={disabled ? onClickFunction : disabled === undefined ? onClickFunction : null}>
        {children}
      </div>
    )
  }
}

export const DataCard = compose(
  ReduxWrapper([

  ],
  [
    ah.sendToURL,
    ah.addLayoutBreadCrumbKey
  ])
)(DataCardPlain)

export class DataCardSelectCheckRow extends React.Component {
  static propTypes = buildPropTypes([
  ], {
    color: pt.string,
    size: pt.string,
    selected: pt.bool,
    onClick: pt.func,
    toolTip: pt.string,
    placement: pt.string,
    overlayClassName: pt.string,
    htmlToolTip: pt.bool,
    fullRow: pt.bool
  })

  static defaultProps = {
    color: 'menu',
    size: '16px',
    placement: 'top',
    htmlToolTip: false,
    fullRow: false
  }

  onClick (e) {
    const { onClick } = this.props
    e.preventDefault()
    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation()
    if (_.isFunction(onClick)) {
      onClick()
    }
  }
  onDoubleClick (e) {
    const { onDoubleClick } = this.props
    e.preventDefault()
    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation()
    if (_.isFunction(onDoubleClick)) {
      onDoubleClick()
    }
  }
  render () {
    const { selected, color, size, toolTip, htmlToolTip } = this.props

    let rowclass = 'selectCheckRow'

    if (toolTip) {
      return <div className={`${rowclass} text-${color || 'menu'}`} onClick={this.onClick.bind(this)} >
        <ToolTip toolTip={toolTip} color={color} placement={'bottomRight'} htmlToolTip={htmlToolTip}>
          <div className='checkWrapper'>
            {selected
              ? <FAIcon name='check' size={size || '12px'} />
              : null
            }
          </div>
        </ToolTip>
      </div>
    } else {
      return <div className={`${rowclass} text-${color || 'menu'}`} onClick={this.onClick.bind(this)} >
        <div className='checkWrapper'>
          {selected
            ? <FAIcon name='check' size={size || '12px'} />
            : null
          }
        </div>
      </div>
    }
  }
}

export class DataCardLockedRow extends React.Component {
  static propTypes = buildPropTypes([
  ], {
    color: pt.string,
    size: pt.string,
    toolTip: pt.string.isRequired,
    icon: pt.string
  })

  static defaultProps = {
    color: 'menu',
    size: '16px',
    toolTip: 'This item is locked',
    icon: 'lock'
  }

  render () {
    const { color, size, toolTip, icon } = this.props

    return <div className={`selectCheckRow text-${color || 'menu'}`} >
      <div className='checkWrapper'>
        <FAIcon name={icon} size={size || '12px'} color={color} toolTip={toolTip || 'This item is locked'} placement='bottomRight' />
      </div>
    </div>
  }
}

class DataCardActionsRowPlain extends React.Component {
  static propTypes = buildPropTypes([
    sh.SessionAccount
  ], {
    actions: pt.arrayOf(pt.shape({
      toolTip: pt.string,
      icon: pt.string,
      color: pt.string,
      onClick: pt.func
    })),
    grouped: pt.bool
  })

  static defaultProps = {
    actions: [],
    grouped: false
  }

  onClick (actionClick, e) {
    const { sendToURL, addLayoutBreadCrumbKey } = this.props

    e.preventDefault()
    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation()

    if (_.isFunction(actionClick)) {
      actionClick()
    } else if (_.isString(actionClick)) {
      sendToURL(actionClick)
    } else if (_.isPlainObject(actionClick)) {
      if (_.isArray(actionClick.breadCrumbKey)) {
        _.each(actionClick.breadCrumbKey, (bk) => {
          addLayoutBreadCrumbKey(bk.key, bk.value, bk.disabled)
        })
      } else {
        addLayoutBreadCrumbKey(actionClick.breadCrumbKey.key, actionClick.breadCrumbKey.value, actionClick.breadCrumbKey.disabled)
      }
      sendToURL(actionClick.url)
    }
  }

  onDoubleClick (actionClick, e) {
    const { sendToURL, addLayoutBreadCrumbKey } = this.props

    e.preventDefault()
    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation()

    if (_.isFunction(actionClick)) {
      actionClick()
    } else if (_.isString(actionClick)) {
      sendToURL(actionClick)
    } else if (_.isPlainObject(actionClick)) {
      if (_.isArray(actionClick.breadCrumbKey)) {
        _.each(actionClick.breadCrumbKey, (bk) => {
          addLayoutBreadCrumbKey(bk.key, bk.value, bk.disabled)
        })
      } else {
        addLayoutBreadCrumbKey(actionClick.breadCrumbKey.key, actionClick.breadCrumbKey.value, actionClick.breadCrumbKey.disabled)
      }
      sendToURL(actionClick.url)
    }
  }

  render () {
    const { actions, SessionAccount, grouped, Label, Status } = this.props

    if (_.isArray(actions) === false) {
      return null
    }

    if (actions.length === 0) {
      return null
    }

    const allowedActions = _.filter(actions, (action) => {
      if (_.isArray(actions.permissions)) {
        return SessionAccount.HasPermissions(action.permissions)
      } else {
        return true
      }
    })

    if (grouped === false) {
      return <div className='actionsRow'>
        {Label ? <Label Status={Status} SessionAccount={SessionAccount}/> : null }
        {_.map(allowedActions, (a, i) => {
          const { onClick, onDoubleClick, ...rest } = a
          return <CircleButton key={i} {...rest} onDoubleClick={(e) => { this.onDoubleClick(onClick, e) }} onClick={(e) => { this.onClick(onClick, e) }} size='sm' />
        })}
      </div>
    } else {
      return <div className='actionsRow'>
        {Label ? <Label Status={Status} SessionAccount={SessionAccount}/> : null }
        <FloatGroup margin={35} direction='left' style={{ margin: '0 10px' }}>
          <CircleButton color='menu' icon='ellipsis-h' size='sm' outline />
          {_.map(allowedActions, (a, i) => {
            const { onClick, onDoubleClick, ...rest } = a
            return <CircleButton key={i} {...rest} onDoubleClick={(e) => { this.onDoubleClick(onClick, e) }} onClick={(e) => { this.onClick(onClick, e) }} size='sm' />
          })}
        </FloatGroup>
      </div>
    }
  }
}

export const DataCardActionsRow = compose(
  ReduxWrapper([
    sh.SessionAccount
  ], [
    ah.addLayoutBreadCrumbKey,
    ah.sendToURL
  ])
)(DataCardActionsRowPlain)

export const DataCardBufferRow = ({ skip }) => {
  const bufferStyle = {
    gridRowEnd: `span ${skip || 1}`
  }

  return <div style={bufferStyle} className='bufferRow'></div>
}

export const DataCardIcon = ({ name, color, size, rowSpan }) => {
  const iconStyle = {
    gridRowEnd: `span ${rowSpan || 1}`
  }

  return <div style={iconStyle} className={`iconRow text-${color || 'menu'}`}>
    <FAIcon name={name} size={size || '12px'} />
  </div>
}

export const DataCardTitle = ({ align, children, size }) => {
  const h2Style = {
    justifySelf: align || 'left',
    fontSize: size || '24px'
  }

  return <h2 style={h2Style}>
    {children}
  </h2>
}

export const DataCardSubTitle = ({ align, children, size, styles = {} }) => {
  const h3Style = {
    justifySelf: align || 'left',
    fontSize: size || '14px',
    ...styles
  }

  return <h3 style={h3Style}>
    {children}
  </h3>
}

class DataCardPicturePlain extends React.Component {
  static propTypes = buildPropTypes([
    sh.SessionToken
  ], {
    icon: pt.string,
    pictureKey: pt.string,
    color: pt.string,
    size: pt.string,
    rowSpan: pt.number,
    heightWidth: pt.number
  })

  static defaultProps = {
    color: 'menu',
    icon: 'user',
    size: '24px',
    rowSpan: 0,
    heightWidth: 80
  }

  render () {
    const { pictureKey, icon, size, rowSpan, SessionToken, heightWidth, queryData = '' } = this.props

    const pictureStyle = {}

    if (rowSpan === 0) {
      pictureStyle.gridRowEnd = -1
    } else if (rowSpan > 1) {
      pictureStyle.gridRowEnd = `span ${rowSpan}`
    }

    return <div style={pictureStyle} className='pictureRow'>
      <div style={{ height: `${heightWidth}px`, width: `${heightWidth}px`, borderRadius: `${heightWidth}px` }} className='pictureWrapper'>
        {pictureKey
          ? <img style={{ maxHeight: `${heightWidth + 5}px` }} src={`/Files/Get/${pictureKey}/?token=${SessionToken}${queryData ? `&${queryData}` : ''}`} />
          : <FAIcon name={icon} size={size} />
        }
      </div>
    </div>
  }
}

export const DataCardPicture = compose(
  ReduxWrapper([
    sh.SessionToken
  ])
)(DataCardPicturePlain)
